'use strict';

module.exports = function push(item) {
  this.items.push(item);

  return this;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/push.js
// module id = 280
// module chunks = 0